import './crossfit.css';

const Crossfit = () => {
    return (
        <a href='/crossfit'>
            <div className="column crossfit">
                <h2 className="title">CROSSFIT</h2>
            </div>
        </a>
    );
}

export default Crossfit;